"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionLinkState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const page_state_1 = require("./page.state");
/**
 * State for linking a collection to a vector field.
 */
class CollectionLinkState {
    get isLinking() {
        return this.fieldId != null;
    }
    beginLinking(fieldId) {
        page_state_1.CurrentState.cancelInteractions();
        this.fieldId = fieldId;
    }
    cancelLinking() {
        this.fieldId = null;
        this.collectionRevision = null;
    }
    completeLinking(collection) {
        this.fieldId = null;
        this.collectionRevision = collection.revision;
    }
}
exports.CollectionLinkState = CollectionLinkState;
tslib_1.__decorate([
    mobx_1.observable
], CollectionLinkState.prototype, "fieldId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CollectionLinkState.prototype, "collectionRevision", void 0);
tslib_1.__decorate([
    mobx_1.computed
], CollectionLinkState.prototype, "isLinking", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionLinkState.prototype, "beginLinking", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionLinkState.prototype, "cancelLinking", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionLinkState.prototype, "completeLinking", null);
//# sourceMappingURL=collection.link.state.js.map